var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLists = function SvgLists(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h3.01v3.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 15.158h20.288V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.222 8)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.44.44a1.505 1.505 0 1 0 2.13 2.13A1.505 1.505 0 0 0 .441.44",
    fill: "#FFC83E",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC83E",
    mask: "url(#d)",
    d: "M5.08 1.95h15.208v-.89H5.081zM.44 6.515a1.505 1.505 0 1 0 2.13 2.128A1.505 1.505 0 0 0 .441 6.515M5.08 8.024h15.208v-.889H5.081zM.44 12.59a1.505 1.505 0 1 0 2.129 2.128A1.505 1.505 0 0 0 .441 12.59m4.639 1.508h15.208v-.89H5.081z"
  }))));
};
export { SvgLists as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iN3A2emd4d2NlYSIgZD0iTTAgMGgzLjAxdjMuMDFIMHoiLz4KICAgICAgICA8cGF0aCBpZD0idHZiMXhkaGFvYyIgZD0iTTAgMTUuMTU4aDIwLjI4OFYwSDB6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjIyMiA4KSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8Zz4KICAgICAgICAgICAgPG1hc2sgaWQ9ImhjNnV0cGVubmIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjN3A2emd4d2NlYSIvPgogICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0uNDQuNDRBMS41MDUgMS41MDUgMCAxIDAgMi41NyAyLjU3IDEuNTA1IDEuNTA1IDAgMCAwIC40NDEuNDQiIGZpbGw9IiNGRkM4M0UiIG1hc2s9InVybCgjaGM2dXRwZW5uYikiLz4KICAgICAgICA8L2c+CiAgICAgICAgPG1hc2sgaWQ9IjQ3eDh0NHJ1OWQiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiN0dmIxeGRoYW9jIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDxwYXRoIGZpbGw9IiNGRkM4M0UiIG1hc2s9InVybCgjNDd4OHQ0cnU5ZCkiIGQ9Ik01LjA4IDEuOTVoMTUuMjA4di0uODlINS4wODF6TS40NCA2LjUxNUExLjUwNSAxLjUwNSAwIDEgMCAyLjU3IDguNjQzIDEuNTA1IDEuNTA1IDAgMCAwIC40NDEgNi41MTVNNS4wOCA4LjAyNGgxNS4yMDh2LS44ODlINS4wODF6TS40NCAxMi41OWExLjUwNSAxLjUwNSAwIDEgMCAyLjEyOSAyLjEyOEExLjUwNSAxLjUwNSAwIDAgMCAuNDQxIDEyLjU5TTUuMDggMTQuMDk4aDE1LjIwOHYtLjg5SDUuMDgxeiIvPgogICAgPC9nPgo8L3N2Zz4K";